// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElecAnalysis_wrapper__2jS3s"};